import { Box, Text ,useColorMode,useColorModeValue} from '@chakra-ui/react'
import React from 'react'
import Card from '../Components/Card'
import html from '../Components/assets/html.svg'
import css from '../Components/assets/css.svg'
import git from '../Components/assets/git.png'
import github from '../Components/assets/github.png'
import vs from '../Components/assets/vs.png'
import mongo from '../Components/assets/mongo.svg'
import react from '../Components/assets/react.svg'
import express from '../Components/assets/express.png'
import ts from '../Components/assets/ts.svg'
import js from '../Components/assets/js.svg'
import node from '../Components/assets/node-js.png'
import {useEffect} from 'react'
import Aos from 'aos'
import "aos/dist/aos.css"
// export interface data{
//   img:string;
//   name:string;
// }
 const Techskill = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  useEffect(() => {
    Aos.init({duration:3000})
   
  }, [])

const Frontenddata=[
  {
    
    img:html,
    name:"HTML"
  },
  {
    img:ts,
    name:"TypeScript"
  },
  {
    img:js,
    name:"JavaScript"
  },
  {
    img:css,
    name:"CSS"
  },
  {img:react,
  name:"React"
},
{img:"https://cdn.iconscout.com/icon/free/png-512/free-redux-3521674-2945118.png?f=avif&w=256",
name:"Redux"
},
{img:"https://img.icons8.com/?size=512&id=r9QJ0VFFrn7T&format=png",
name:"Chakra UI"},
{img:"https://img.icons8.com/?size=512&id=gFw7X5Tbl3ss&format=png",
name:"Material UI"}

]
const backenddata=[
  {
    img:express,
    name:"Express.js"
  },
  {
    img:mongo,
    name:"MongoDB"
  },
  {
    img:node,
    name:"Node.js"
  }
  ,
  {
    img:"https://dashboard.render.com/static/media/logo-redesign-02-word-dark.0811da26fe4b1f9a9b6c642d91bbcf73.svg",
    name:"Render"
  }
  ,
  {
    img:"https://img.icons8.com/?size=512&id=rHpveptSuwDz&format=png",
    name:"Web Token"
  }
  
]
const toolsdata=[
  {
    img:git,
    name:"Git"
  },{
    img:github,
    name:"Github"
  },{
    img:vs,
    name:"VS Code"
  },{
    img:"https://img.icons8.com/?size=512&id=EPbEfEa7o8CB&format=png",
    name:"Postman"
  }
  ,{
    img:"https://img.icons8.com/?size=512&id=20795&format=png",
    name:"Code Pen"
  }
  ,{
    img:"https://img.icons8.com/?size=512&id=sBo1RJ3rjbje&format=png",
    name:"Netlify"
  }
]
  return (
  <Box overflow="hidden" maxWidth={"100%"} color={colorMode==='light'?"black":"white"}>
<h1 style={{fontSize:"40px",textAlign:"center",marginTop:"20px",color:colorMode=="light"?"black":"white"}}>Technical Skills</h1>
  <div data-aos="fade-up"   id="skills" style={{backgroundColor:"black"}} mt={{base:"50px",sm:"50px",md:"30px",xl:"30px"}} >
    <div className='skillcont'>

  <h1 style={{textAlign:"center",fontSize:"30px",color:"white"}}>FrontEnd</h1>
  <div class="skills-card" style={{height:"auto"}}>

<div className='frontend'  style={{display:"flex",flexWrap:"wrap",height:"auto"}}>
{Frontenddata.map((item,i)=>{
  return <Card key={i} id={i}  img={item.img} name={item.name}/>
})}
</div>
</div>
  
  <Text  style={{textAlign:"center",fontSize:"30px",color:"white"}}>BackEnd</Text>
  <div class="skills-card" style={{height:"auto"}}>

<Box h="auto"  className='backend'>

{backenddata.map((item,i)=>{
  return <Card key={i} id={i} img={item.img} name={item.name}/>
})}

</Box>
</div>
<h1 style={{marginTop:"10px",textAlign:"center",fontSize:"30px",color:"white"}}>Tools</h1>
<div class="skills-card">

<div className='tools'>
{toolsdata.map((item,i)=>{
  return <Card  key={i} id={i}  img={item.img} name={item.name}/>
})}
</div>


</div>
    </div>
  </div>
  </Box>
  )
}
export default Techskill
